import { type ComponentProps } from "react";

export const PartlyCloudy = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2V5H17V2H15ZM20.6124 21.2657C22.0759 19.9827 23 18.0992 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 16.1418 9.00422 16.2826 9.01253 16.4223C8.32778 16.663 7.68849 17.0002 7.11101 17.4176C7.03795 16.9558 7 16.4824 7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16C25 18.4685 24.0062 20.7049 22.3968 22.3309C21.8886 21.8603 21.2825 21.4938 20.6124 21.2657ZM27 15H30V17H27V15ZM27.6243 8.13397L25.0263 9.63397L26.0263 11.366L28.6243 9.86603L27.6243 8.13397ZM20.634 5.97381L22.134 3.37573L23.8661 4.37573L22.3661 6.97381L20.634 5.97381ZM8.13397 4.37573L9.63397 6.97381L11.366 5.97381L9.86603 3.37573L8.13397 4.37573ZM5.97375 11.366L3.37567 9.86603L4.37567 8.13397L6.97375 9.63397L5.97375 11.366ZM5 15H2V17H5V15ZM27.6244 23.866L25.0263 22.366L26.0263 20.634L28.6244 22.134L27.6244 23.866Z"
      fill="url(#paint0_linear_1554_20111)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 28C11.5278 28 11.5556 27.9998 11.5833 27.9994H18.9332C18.946 27.9997 18.9588 27.9999 18.9716 28H19V28.0001C19 28.0001 19 28.0001 19 28.0001C20.6569 28.0001 22 26.657 22 25.0001C22 23.3433 20.6569 22.0001 19 22.0001C18.2306 22.0001 17.5289 22.2897 16.9979 22.7659C17.0021 22.6779 17.0042 22.5893 17.0042 22.5002C17.0042 21.825 16.8825 21.1781 16.6598 20.5804C17.358 20.21 18.1545 20.0001 19 20.0001C21.7614 20.0001 24 22.2387 24 25.0001C24 27.7616 21.7614 30.0001 19 30.0001C18.9878 30.0001 18.9756 30.0001 18.9634 30L11.5388 30V29.9999C11.5258 30 11.5129 30 11.5 30C7.35787 30 4 26.6422 4 22.5C4 18.3579 7.35787 15 11.5 15C14.7721 15 17.5548 17.0954 18.5794 20.0175C17.889 20.075 17.2385 20.2728 16.6564 20.5822C15.878 18.4902 13.8631 17 11.5 17C8.46244 17 6 19.4624 6 22.5C6 25.5376 8.46244 28 11.5 28Z"
      fill="url(#paint1_linear_1554_20111)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1554_20111"
        x1="16"
        y1="2"
        x2="16"
        y2="23.866"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFC977" />
        <stop offset="1" stopColor="#E07256" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1554_20111"
        x1="14"
        y1="15"
        x2="14"
        y2="30.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B2D4F7" />
        <stop offset="1" stopColor="#D9E2F3" />
      </linearGradient>
    </defs>
  </svg>
);
